<template>
  <div class="w-100">
    <file-list :fileType="9" :filePath="'/'" :type="0"></file-list>
  </div>
</template>

<script>
import FileList from './file/fileList.vue'
export default {
  components: {
    FileList
  }
}
</script>

<style>
</style>